// extracted by mini-css-extract-plugin
export var addButton = "_ii-0";
export var border = "_ii-8";
export var check = "_ii-h";
export var danger = "_ii-6";
export var dropdownContainer = "_ii-1";
export var editModalBody = "_ii-j";
export var footerContainer = "_ii-i";
export var fullWidth = "_ii-a";
export var hide = "_ii-9";
export var icon = "_ii-3";
export var input = "_ii-7";
export var inputFlex = "_ii-b";
export var inputWrapper = "_ii-c";
export var manualFocus = "_ii-5";
export var optionButton = "_ii-4";
export var pillWrapper = "_ii-e";
export var pointer = "_ii-2";
export var showOverflow = "_ii-f";
export var tagsFlex = "_ii-d";
export var xButton = "_ii-g";